"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _Title = _interopRequireDefault(require("../01_atoms/Title"));

var _HomeTopBar = _interopRequireDefault(require("../02_molecules/HomeTopBar"));

var _OrdersListWidget = _interopRequireDefault(require("../03_organisms/OrdersListWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var OrdersPage = function OrdersPage(_ref) {
  var tickets = _ref.tickets,
      isFiltered = _ref.isFiltered,
      onUnfilter = _ref.onUnfilter,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('OrdersPageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement(_HomeTopBar["default"], {
    translatorForNamespace: translatorForNamespace,
    selectedTab: "orders"
  }), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      marginTop: 20
    }
  }, t('Your next trips')), /*#__PURE__*/_react["default"].createElement(_OrdersListWidget["default"], {
    tickets: tickets,
    isFiltered: isFiltered,
    onUnfilter: onUnfilter,
    translationManager: translationManager,
    translatorForNamespace: translatorForNamespace,
    translator: t
  }));
};

var _default = OrdersPage;
exports["default"] = _default;